export const MUNICIPIOS_MOCK = [
  {
    id: 123,
    label: "Municipio qualquer"
  }
];

export const MODALIDADE_PESCA_MOCK = [
  {
    cod: 0,
    descricao_pt: "Pesca Esportiva",
    descricao_en: "Sport Fishing",
    descricao_es: "Pesca Deportiva"
  },
  {
    cod: 1,
    descricao_pt: "Pesca Recreativa",
    descricao_en: "Recreational Fishing",
    descricao_es: "Pesca Recreativa"
  }
];

export const LOCALIZACAO_PREF_PESCA_MOCK = [
  {
    cod: 0,
    descricao_pt: "Localmente",
    descricao_en: "Locally",
    descricao_es: "Localmente"
  },
  {
    cod: 1,
    descricao_pt: "Em outros estados",
    descricao_en: "In other states",
    descricao_es: "En otros estados"
  },
  {
    cod: 2,
    descricao_pt: "Em outros países",
    descricao_en: "In other countries",
    descricao_es: "En otros países"
  }
];

export const RENDA_MENSAL_MOCK = [
  {
    cod: 0,
    descricao_pt: "Nenhuma renda",
    descricao_en: "No income",
    descricao_es: "Ninguna renta"
  },
  {
    cod: 1,
    descricao_pt: "Até um salário mínimo",
    descricao_en: "Up to a minimum wage",
    descricao_es: "Hasta un salario mínimo"
  },
  {
    cod: 2,
    descricao_pt: "De 1 a 3 salários mínimos",
    descricao_en: "From 1 to 3 minimum wages",
    descricao_es: "De 1 a 3 salarios mínimos"
  },
  {
    cod: 3,
    descricao_pt: "De 3 a 6 salários mínimos",
    descricao_en: "From 3 to 6 minimum wages",
    descricao_es: "De 3 a 6 salarios mínimos"
  },
  {
    cod: 4,
    descricao_pt: "De 6 a 9 salários mínimos",
    descricao_en: "From 6 to 9 minimum wages",
    descricao_es: "De 6 a 9 salarios mínimos"
  },
  {
    cod: 5,
    descricao_pt: "De 9 a 12 salários mínimos",
    descricao_en: "From 9 to 12 minimum wages",
    descricao_es: "De 9 a 12 salarios mínimos"
  },
  {
    cod: 6,
    descricao_pt: "De 12 a 15 salários mínimos",
    descricao_en: "From 12 to 15 minimum wages",
    descricao_es: "De 12 a 15 salarios mínimos"
  },
  {
    cod: 7,
    descricao_pt: "Mais de 15 salários mínimos",
    descricao_en: "More then 15 minimum wages",
    descricao_es: "Más de 15 salarios mínimos"
  }
];

export const FAIXA_ETARIA_MOCK = [
  {
    cod: 0,
    descricao_pt: "De 0 a 20 anos",
    descricao_en: "To 0 to 20 years old",
    descricao_es: "De 0 a 20 años"
  },
  {
    cod: 1,
    descricao_pt: "De 21 a 30 anos",
    descricao_en: "To 21 to 30 years old",
    descricao_es: "De 21 a 30 años"
  },
  {
    cod: 2,
    descricao_pt: "De 31 a 40 anos",
    descricao_en: "To 31 to 40 years old",
    descricao_es: "De 31 a 40 años"
  },
  {
    cod: 3,
    descricao_pt: "De 41 a 50 anos",
    descricao_en: "To 41 to 50 years old",
    descricao_es: "De 41 a 50 años"
  },
  {
    cod: 4,
    descricao_pt: "De 51 a 60 anos",
    descricao_en: "To 51 to 60 years old",
    descricao_es: "De 51 a 60 años"
  },
  {
    cod: 5,
    descricao_pt: "De 61 a 70 anos",
    descricao_en: "To 61 to 70 years old",
    descricao_es: "De 61 a 70 años"
  },
  {
    cod: 6,
    descricao_pt: "Mais que 71 anos",
    descricao_en: "More then 71 years old",
    descricao_es: "Más de 71 años"
  }
];

export const LOCAL_PESCA_MOCK = [
  {
    cod: 0,
    descricao_pt: "Mar",
    descricao_en: "Sea",
    descricao_es: "Mar"
  },
  {
    cod: 1,
    descricao_pt: "Água doce",
    descricao_en: "Fresh water",
    descricao_es: "Agua dulce"
  }
];

export const MATERIAL_PESCA_MOCK = [
  {
    cod: 0,
    descricao_pt: "Linha Caniço",
    descricao_en: "Caniço line",
    descricao_es: "Línea Caniço"
  },
  {
    cod: 1,
    descricao_pt: "Carretilha Molinete",
    descricao_en: "Windlass Reel",
    descricao_es: "Carretilla Molinete"
  },
  {
    cod: 2,
    descricao_pt: "Fly",
    descricao_en: "Fly",
    descricao_es: "Fly"
  },
  {
    cod: 3,
    descricao_pt: "Outros",
    descricao_en: "Others",
    descricao_es: "Otro"
  }
];

export const TIPO_ISCA_MOCK = [
  {
    cod: 0,
    descricao_pt: "Natural",
    descricao_en: "Natural",
    descricao_es: "Natural"
  },
  {
    cod: 1,
    descricao_pt: "Artificial",
    descricao_en: "Artificial",
    descricao_es: "Artificial"
  }
];

export const AGENCIA_TURISMO_MOCK = [
  {
    cod: 0,
    descricao_pt: "Sim",
    descricao_en: "Yes",
    descricao_es: "Sí",
    value: true
  },
  {
    cod: 1,
    descricao_pt: "Não",
    descricao_en: "No",
    descricao_es: "No",
    value: false
  }
];

export const STATUS_MOCK = [
  {
    cod: 0,
    descricao_pt: "Aguardando pagamento",
    descricao_en: "Awaiting payment",
    descricao_es: "Esperando el pago"
  },
  {
    cod: 1,
    descricao_pt: "Ativo",
    descricao_en: "Active",
    descricao_es: "Activo"
  },
  {
    cod: 2,
    descricao_pt: "Inativada",
    descricao_en: "Inactivated",
    descricao_es: "Inactivada"
  }
];

export const PEIXE_MAIS_PESCADO = [
  {
    cod: 13,
    descricao_pt: "Tucunaré",
    descricao_en: "Tucunaré",
    descricao_es: "Tucunaré"
  },
  {
    cod: 14,
    descricao_pt: "Outros",
    descricao_en: "Others",
    descricao_es: "Otro"
  }
];
